<lib-modal [hideCloseButton]="true" class="w-96">
  <header modal-header class="p-6 flex flex-col gap-4 items-center">
    <lib-svg class="[&_svg]:size-5" svg="fontawesome/badge-percent" />
    <h2 class="text-center text-2xl font-normal">
      {{ data.modalTitle }}
    </h2>
  </header>

  <main modal-body class="px-6 pb-2">
    @if (loading()) {
      <ngx-skeleton-loader
        class="w-full flex flex-col gap-4 [&_.skeleton-loader]:!h-28 [&_.skeleton-loader]:!block [&_.skeleton-loader]:!m-0"
        count="2"
      />
    } @else {
      @if (promotions()?.length > 0) {
        <mat-radio-group class="gap-4 flex flex-col" color="primary" [formControl]="control">
          @for (promotion of promotions(); track promotion.id) {
            <mat-radio-button
              class="overflow-hidden border border-solid border-[--color-gray-3] rounded-[--border-radius-product-boxes] shadow-[0_4px_4px_rgba(0,0,0,0.15)] flex [&_>div]:flex [&_>div]:flex-1 [&_label]:flex-1"
              labelPosition="before"
              [value]="promotion.id"
            >
              <lib-product-box-pricing
                class="flex flex-col p-1 gap-y-2 cursor-pointer"
                [product]="data.product"
                [promotion]="promotion"
              />
            </mat-radio-button>
          }
        </mat-radio-group>
      } @else {
        {{ ['product_selection', 'promotions_none_available'] | translate }}
      }
    }
  </main>

  <footer modal-footer class="p-6">
    <div class="flex gap-4 justify-end">
      <lib-button
        [text]="['product_selection', 'promotions_modal_cancel_btn_text'] | translate"
        type="mat-text-button"
        (clickEvent)="onCancelClick()"
      />
      @if (promotions()?.length > 0) {
        <lib-button
          [text]="['product_selection', 'promotions_modal_submit_btn_text'] | translate"
          type="mat-filled-button"
          [disabled]="!optionSelected()"
          (clickEvent)="onSubmitClick()"
        />
      }
    </div>
  </footer>
</lib-modal>
